export default __webpack_public_path__ + "static/media/cp_geo_uy.f53324b6.svg";